import { render } from "./pedido-detalhe.vue?vue&type=template&id=c7b29fcc"
import script from "./pedido-detalhe.vue?vue&type=script&lang=js"
export * from "./pedido-detalhe.vue?vue&type=script&lang=js"

import "./pedido-detalhe.vue?vue&type=style&index=0&id=c7b29fcc&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__